import { makeStyles, Text } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const useStyles = makeStyles({
    legalLink: {
        color: 'white',
        lineHeight: '1.5',
        textDecoration: 'none',
        display: 'block',
        
        '&:hover': {
            opacity: 1,
            color: "white",
            textDecoration: 'underline',
        }
    }
});

const Legal = () => {
    const { t } = useTranslation("navigation");
    const styles = useStyles();

    return (
        <div>
            <Text block>{t("legal.title")}</Text>
            <Link to="/legal/terms" className={styles.legalLink}>{t("legal.policies.terms")}</Link>
            <Link to="/legal/privacy-policy" className={styles.legalLink}>{t("legal.policies.privacy")}</Link>
            <Link to="/legal/cookie-policy" className={styles.legalLink}>{t("legal.policies.cookies")}</Link>
            <Link to="/legal/recruitment-policy" className={styles.legalLink}>{t("legal.policies.recruitment")}</Link>
            <Link to="/legal/modern-slavery" className={styles.legalLink}>{t("legal.policies.slavery")}</Link>
        </div>
    );
}

export default Legal;